import React from 'react';

import { SearchField } from '@/components/NewUI/ComponentsLibrary';

import { useDebouncedSearch } from '../../hooks/useDebouncedSearch';

import type { Dispatch } from 'react';

import type { GenericTableAction } from './genericTableReducer';

const SearchInput = ({
  dispatch,
  id,
  placeholder = 'Search by title'
}: {
  dispatch: Dispatch<GenericTableAction>;
  id?: string;
  placeholder?: string;
}) => {
  const { value, onChange } = useDebouncedSearch((searchQuery) => {
    dispatch({ type: 'SET_SEARCH_QUERY', payload: searchQuery });
  });

  return (
    <SearchField
      fullWidth
      id={id ?? 'records-search'}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
    />
  );
};

export default SearchInput;
